const OFFLINE_MESSEGE = 'You are offline'
const WAIT = 'Please wait...'
export default {
    OFFLINE_MESSEGE,
    WAIT
}